export enum BaryUploadUrlEnum {
  PRICING_TRANSPORTER = '/upload/PRICING/TRANSPORTER/',
  PRICING_CUSTOMER_OFFER = '/upload/PRICING/CUSTOMER/',
  CUSTOMER_TRANSPORTER = '/upload/CUSTOMER/TRANSPORTER/',
  ACCEPTANCE = '/upload/ACCEPTANCE/TRANSPORTER/',
  CUTOFF = '/upload/CUTOFF/TRANSPORTER/',
  MAINLOGO = '/img/upload/main-logo/',
  DISCONNECTEDLOGO = '/img/upload/disconnected-logo/',
  SPLASHLOGO = '/img/upload/splash-logo/',
  TRANSPORTERMEMBER = '/img/upload/transporter-member/',
  THEME_DESCRIPTION_IMAGE = '/img/upload/theme/',
  CGV = '/upload/cgv/',
  SPECIAL_PLACE_MOUNTAIN = '/upload/MOUNTAIN/TRANSPORTER/',
  SPECIAL_PLACE_ISLE = '/upload/ISLE/TRANSPORTER/',
  SPECIAL_PLACE_FORBIDDEN = '/upload/FORBIDDEN/TRANSPORTER/',
}
